/**
 * Existence Status of an entity
 */ export var ExistenceStatus = /*#__PURE__*/ function(ExistenceStatus) {
    /**
     * Entity has been created
     */ ExistenceStatus[ExistenceStatus["Created"] = 0] = "Created";
    /**
     * Entity has been deleted in the client but not propagated to the authoritative store yet
     */ ExistenceStatus[ExistenceStatus["SoftDeleted"] = 1] = "SoftDeleted";
    /**
     * Entity has been deleted on server but is maintained on client
     * in case user performs an Undo and we need to recover it.
     */ ExistenceStatus[ExistenceStatus["ServerDeleted"] = 2] = "ServerDeleted";
    return ExistenceStatus;
}({});
